import { useCallback, useEffect, useState } from "react";

import { Controller, useFormContext, useWatch } from "react-hook-form";

import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Paper,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";

import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../../ui";

const OutletAvailabilitySection = () => {
  const { control } = useFormContext();
  const { showSnackbar } = useSnackbar();
  const [outlets, setOutlets] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadOutlets = useCallback(async () => {
    setIsLoading(true);
    try {
      const {
        data: { data },
      } = await apiClient.get("/outlets");
      setOutlets(data);
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memuat cabang toko"));
    } finally {
      setIsLoading(false);
    }
  }, [showSnackbar]);

  useEffect(() => {
    loadOutlets();
  }, [loadOutlets]);

  const availableToAllOutlets = useWatch({
    control,
    name: "availableToAllOutlets",
  });

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6">Outlet</Typography>
      <Stack direction="row" spacing={2} sx={{
        alignItems: "center"
      }}>
        <Typography variant="body2">Tersedia di semua outlet</Typography>
        <Controller
          name="availableToAllOutlets"
          control={control}
          render={({ field }) => (
            <Switch
              {...field}
              checked={field.value}
              onChange={(e) => field.onChange(e.target.checked)}
            />
          )}
        />
      </Stack>
      {!availableToAllOutlets && (
        <>
          {isLoading ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 1
              }}>
              <CircularProgress size={24} />
              <Typography variant="body2" sx={{ ml: 1 }}>
                Loading...
              </Typography>
            </Box>
          ) : outlets.length === 0 ? (
            <Typography variant="caption" sx={{ mt: 1 }}>
              Tidak ada outlet yang tersedia.
            </Typography>
          ) : (
            <Grid container columnSpacing={2.5} rowSpacing={1} sx={{ mt: 1 }}>
              {outlets.map((outlet) => (
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={outlet.id}>
                  <Controller
                    name={`outlets.${outlet.id}`}
                    control={control}
                    render={({ field }) => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            {...field}
                            checked={field.value || false}
                            onChange={(e) => field.onChange(e.target.checked)}
                          />
                        }
                        label={outlet.name}
                      />
                    )}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </>
      )}
    </Paper>
  );
};

export default OutletAvailabilitySection;
